import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const AthletePropositionBetModuleAsyncComponent = AsyncComponent(async () => import('./athlete-proposition-bet-module' /* webpackChunkName: "athlete-proposition-bet-module" */ ));

export const AthletePropositionBetModuleAsync = (props) => {
  return <React.Suspense fallback={<div/>}>
    <AthletePropositionBetModuleAsyncComponent {...props}/>
  </React.Suspense>
};
